import React, { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import BrandTable from 'src/components/BrandTable2';
import ReportExportPDF from 'src/components/ReportExportPDF';
import {
  DataBlock,
  DataBlockChunk
} from 'src/components/ReportExportPDF/InputData';
import downloadPDF from 'src/components/ReportExportPDF/downloadPDF';
import { DAILY_RUN_REPORT } from 'src/config/api.config';
import useRefMounted from 'src/hooks/useRefMounted';
import AddressService from 'src/services/Address.service';
import ReportService from 'src/services/Report.service';
import DateTimeService from 'src/utils/DateTimeService';
import TransformService from 'src/utils/TransformationService';
import axiosInt from 'src/utils/axios';

const dataChunkRegex = /^data:/;

function ResultTable({ filter }) {
  const isMountedRef = useRefMounted();
  const [dailyRunSummary, setDailyRunSummary] = useState([]);
  const [loading, setLoading] = useState(false);

  const tableConfig = [
    {
      headerName: 'Sr',
      accessor: 'serialId',
      field: 'serialId',
      width: 100
    },

    {
      headerName: 'Zone',
      accessor: 'zone',
      field: 'zone',
      width: 200
    },

    {
      headerName: 'Ward',
      accessor: 'ward',
      field: 'ward',
      width: 200
    },

    {
      headerName: 'Vehicle Type',
      accessor: ({ model }) => model || '-',
      field: 'model',
      width: 200
    },
    {
      headerName: 'Vehicle Number',
      accessor: 'regNo',
      field: 'regNo'
    },
    // {
    //   headerName: 'Area',
    //   accessor: () => '-',
    //   field: 'area'
    // },

    {
      headerName: 'Distance (km)',
      accessor: ({ distance }) =>
        !distance ? 0 : `${(distance / 1000).toFixed(2)}`,
      field: 'distance'
    },

    {
      headerName: 'Avg Speed (km/h)',
      accessor: ({ averageSpeed }) =>
        !averageSpeed ? '-' : `${averageSpeed.toFixed(2)}`,
      field: 'averageSpeed'
    },
    {
      headerName: 'Fuel Consumption',
      accessor: ({ fuelConsumed }) =>
        !fuelConsumed ? 0 : `${fuelConsumed.toFixed(2)}`
    }
  ];

  const modifiedTableConfig = tableConfig.filter(
    (config) => config.Header !== 'Vehicle'
  );

  const modifiedHeadings = tableConfig
    .filter((config) => config.Header !== 'Vehicle')
    .map((config) => config.Header);

  const pdfTableData = dailyRunSummary.map((item) =>
    modifiedTableConfig.map((config) => {
      if (typeof config.accessor === 'function') {
        return config.accessor(item);
      }

      const accessorValue = item[config.accessor];

      switch (config.Header) {
        case 'Start Time':
        case 'End Time':
          return DateTimeService.getDateTimeString(accessorValue);
        case 'Distance':
          return `${(accessorValue / 1000).toFixed(2)} km`;
        case 'Engine Utilisation':
          return (accessorValue / 3600000).toFixed(2);
        case 'Avg Speed':
        case 'Max Speed':
          return `${accessorValue.toFixed(2)} km/h`;
        default:
          return accessorValue || 'N/A';
      }
    })
  );

  // const pdfDocument = (
  //   <ReportExportPDF
  //     reportName="Summary Report"
  //     dataBlocks={[
  //       new DataBlock('Vehicle Information', [
  //         new DataBlockChunk(
  //           'Vehicle Name',
  //           [dailyRunSummary?.[0]]?.map((item) => item?.vehicleName)
  //         )
  //         // new DataBlockChunk(
  //         //   'Vehicle Registration',
  //         //   [dailyRunSummary[0]].map((item) => item.registrationNumber)
  //         // )
  //       ])
  //     ]}
  //     tableData={{
  //       headings: modifiedHeadings,
  //       tableData: pdfTableData
  //     }}
  //   />
  // );

  const getDailyRunReport = useCallback(
    async (filter) => {
      try {
        const { data: cumulativeData } =
          await ReportService.getCumulativeReport(filter);
        setDailyRunSummary(
          cumulativeData.map((d, i) => ({ ...d, serialId: i + 1 }))
        );
      } catch (err) {
        console.error('kakndnakdkasnd', err);
        toast.error(err.message ?? err);
      } finally {
        setLoading(false);
      }
    },
    [isMountedRef]
  );

  // const getDailyRunReport = useCallback(async () => {
  //   try {
  //     setLoading(true);

  //     const _dailyRunData = [];

  //     // if (!filter.vehicleIds)
  //     //   throw new Error('Select atleast 1 vehicle to get report');
  //     filter.vehicleIds = (filter.vehicleIds ?? []).join(',');
  //     const data = await ReportService.getDailyRunReport(filter);

  //     const chunks = data.split('\n\n');

  //     // eslint-disable-next-line no-restricted-syntax
  //     for (const chunk of chunks) {
  //       // eslint-disable-next-line no-continue
  //       if (!chunk) continue;

  //       const dataChunkRegex = /^data:/;

  //       if (dataChunkRegex.test(chunk)) {
  //         const rawData = chunk.replace('data:', '').trim();
  //         const json = JSON.parse(rawData);

  //         if (json.type === 'data') {
  //           const startPos = json.data.startPos;
  //           const endPos = json.data.endPos;

  //           // eslint-disable-next-line no-await-in-loop
  //           const [startAddress, endAddress] = await Promise.all([
  //             !startPos
  //               ? '-'
  //               : AddressService.get({
  //                   latitude: startPos.lat,
  //                   longitude: startPos.long
  //                 }).catch(() => Object.values(startPos).join(',')),
  //             !endPos
  //               ? '-'
  //               : AddressService.get({
  //                   latitude: endPos.lat,
  //                   longitude: endPos.long
  //                 }).catch(() => Object.values(endPos).join(','))
  //           ]);

  //           json.data.startAddress = startAddress;
  //           json.data.endAddress = endAddress;

  //           _dailyRunData.push(json.data);
  //         }
  //       } else {
  //         toast.error('Could not fetch data!');
  //         return;
  //       }

  //       setDailyRunSummary(_dailyRunData);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     toast.error(err.message ?? err);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [isMountedRef, filter]);

  useEffect(() => {
    console.log(filter);
    if (!Object.keys(filter).length) return;
    getDailyRunReport(filter);
  }, [filter]);

  return (
    <BrandTable
      loading={loading}
      tableConfig={tableConfig}
      tableData={dailyRunSummary}
      noResultsMessage="We could not find summary data in your search"
      generateFileName={() =>
        `Cumulative_Distance_Report_${DateTimeService.getDateTimeString(
          filter.fromDate
        )}_to_${DateTimeService.getDateTimeString(filter.toDate)}`
      }
    />
  );
}

export default ResultTable;
